import { CardSettings } from "./CardSettings";

export { CardSettings };
export default CardSettings;